export function extractPathname(url: string): string {
  const parsedUrl = new URL(url, 'https://localhost');
  return parsedUrl.pathname;
}
